import { useMatch } from "@tanstack/react-router";

// The chrome (header/school-selector) only renders inside the `$school` layout, but — like
// portal — these hooks are written defensively so an off-scope render returns empty rather
// than throwing.
const SCHOOL_ROUTE_ID = "/$locale/{-$schoolyear}/_authenticated/$school";

/** The `$school` layout loaderData, or `null` when rendered outside that layout. */
export function useSchoolLayoutData() {
  return useMatch({ from: SCHOOL_ROUTE_ID, shouldThrow: false })?.loaderData ?? null;
}

/** The current user's schools (empty when rendered outside the `$school` layout). */
export function useSchools() {
  return useSchoolLayoutData()?.scholen ?? [];
}
